import { Link } from 'react-router-dom'
import ServerStatus from './ServerStatus'

export default function Header() {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-blue-600">
            MPCFillToPDF Web
          </Link>
          <div className="flex items-center gap-4">
            <ServerStatus />
            <nav className="flex gap-4">
            <Link
              to="/"
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              Home
            </Link>
            <Link
              to="/builder"
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              Builder
            </Link>
            </nav>
          </div>
        </div>
      </div>
    </header>
  )
}
